import Heading from "../../heading/heading.component";
import AuctionItem from "../auction-item/auction-item.component";
import { CMAuctionStatus } from "./auction-status.styles";


export const AUCTION_TYPE = {
    progress: {
        id: 'progress',
        title: 'Auctions in progress',
        isValid: true,
    },
    upcoming: {
        id: 'upcoming',
        title: 'Upcoming Auctions',
        isValid: true,
    },
    scheduled: {
        id: 'scheduled',
        title: 'Scheduled Auctions',
        isValid: true,
    },
    mobile: {
        id: 'mobile',
        title: '',
        isValid: false,
    },
    details: {
        id: 'details',
        title: '',
        isValid: false,
    },
    trade: {
        id: 'trade',
        title: '',
        isValid: false,
    },
    finished: {
        id: 'finished',
        title: '',
        isValid: false,
    },
}

const AuctionStatus = ({title, auctionsList, auctionType}) => {
    return (
        <CMAuctionStatus className={`dotted-border auction-${auctionType}`}>
            
            <Heading previusPage={title} />

            {auctionsList && auctionType === AUCTION_TYPE.scheduled.id  ?
                <>
                    {auctionsList && auctionsList.length > 0 ?
                        auctionsList.map((auction, index) => {
                            return <AuctionItem key={index} auction={auction} position={index}/>
                        }): ''
                    }
                </>
                :
                <>
                    {auctionsList && auctionsList.length > 0 ? (
                        auctionsList.map((auction, index) => (
                            <AuctionItem key={index} auction={auction} position={index} />
                        ))
                        ) : (
                        ''
                        )}

                </>
                
            }
        </CMAuctionStatus>
    );
}

export default AuctionStatus;